import React, { PureComponent, Fragment } from 'react'
import { observer } from 'mobx-react'
import { action, makeObservable, observable } from 'mobx'
import classNames from 'classnames'

import { COURSE_QUIZ_CLASS_NAMES } from '@elo-kit/constants/customCss.constants'
import { QUIZ_QUESTION_TYPES, PREFILLED_INFO_KEYS } from 'constants/quiz.constants'

import { LoadingMask } from '@elo-kit/components/loading-mask/LoadingMask'
import { RadioField } from '@elo-kit/components/form/radio-field/RadioField'
import { CheckboxField } from '@elo-kit/components/form/checkbox-field/CheckboxField'
import { EloButton } from '@elo-kit/components/elo-button/EloButton'
import { TextEditorField } from '@elo-kit/components/form/text-editor-field/TextEditorField'

import CustomButton from '../custom-button/CustomButton'

@observer
class QuizForm extends PureComponent {
  @observable quizData = new Map()
  @observable initialPrefillArray = []

  constructor(props) {
    super(props)
    makeObservable(this)
  }

  componentDidMount() {
    const { quizzesStore, payerStore } = this.props

    const { item: quiz } = quizzesStore
    const { item: payer } = payerStore

    const { quizQuestions } = quiz || {}

    const quizPrefillTypeObject = {
      [PREFILLED_INFO_KEYS.phone]: payer.phone,
      [PREFILLED_INFO_KEYS.email]: payer.email,
      [PREFILLED_INFO_KEYS.fullName]: payer.fullName,
    }

    if (quizQuestions) {
      quizQuestions.forEach((question) => {
        const { id: questionId, prefillType } = question || {}

        if (prefillType) {
          this.setOpenQuestion(questionId, quizPrefillTypeObject[prefillType])
          this.setInitialPrefillArray(questionId)
        }
      })
    }
  }

  @action setInitialPrefillArray = (value) => this.initialPrefillArray.push(value)

  @action setOpenQuestion = (questionId, answer) => {
    this.quizData.set(questionId, {
      quizQuestionId: questionId,
      body: answer,
    })
  }

  @action setSingleQuestion = (e, questionId) => {
    const { checked, id } = e.target

    if (checked) {
      this.quizData.set(questionId, {
        quizQuestionId: questionId,
        quizChoiceIds: [id],
      })
    }
  }

  @action setMultipleQuestion = (e, questionId) => {
    const { checked, name } = e.target

    const questionData = this.quizData.get(questionId)

    if (checked) {
      if (questionData) {
        const choices = questionData.quizChoiceIds.slice()
        choices.push(name)

        this.quizData.set(questionId, {
          quizQuestionId: questionId,
          quizChoiceIds: choices,
        })
      } else {
        this.quizData.set(questionId, {
          quizQuestionId: questionId,
          quizChoiceIds: [name],
        })
      }
    } else {
      const choices = questionData.quizChoiceIds.slice()
      const filteredChoices = choices.filter((item) => String(item) !== String(name))

      this.quizData.set(questionId, {
        quizQuestionId: questionId,
        quizChoiceIds: filteredChoices,
      })
    }
  }

  render() {
    const { quizzesStore, courseViewsStore, sellerFontsStore, defaultTheme } = this.props

    const { item: quiz, loading } = quizzesStore

    const { introduction, quizQuestions } = quiz || {}

    const { submitQuiz } = courseViewsStore

    return (
      <Fragment>
        {loading ? (
          <LoadingMask />
        ) : (
          <div
            className={classNames(COURSE_QUIZ_CLASS_NAMES.formContainerClassName, 'quiz', 'fr-view', 'white-widget')}
          >
            {introduction ? (
              <div className='intro' dangerouslySetInnerHTML={{ __html: introduction }} />
            ) : (
              <div className='intro'>{I18n.t('shared.common.quiz')}</div>
            )}

            <div className='quiz-form'>
              {!!quizQuestions.length &&
                quizQuestions.map((question, index) => {
                  const { choices = [], form, id: questionId, title } = question || {}

                  const questionData = this.quizData.get(questionId)

                  return (
                    <div className='question' key={`${questionId}-${index}-${this.initialPrefillArray.length}`}>
                      <div className='question-title'>
                        {index + 1}. <span dangerouslySetInnerHTML={{ __html: title }} />
                      </div>

                      {form === QUIZ_QUESTION_TYPES.text && (
                        <div className='choices'>
                          <div className='choice'>
                            <TextEditorField
                              name='answer'
                              value={(questionData || {}).body}
                              onChange={(value) => this.setOpenQuestion(questionId, value)}
                              fontFamilyList={sellerFontsStore.froalaFonts}
                            />
                          </div>
                        </div>
                      )}

                      {form === QUIZ_QUESTION_TYPES.single && (
                        <div className='choices'>
                          {choices.map((choice) => {
                            const { body, id } = choice || {}

                            const singleValue = questionData && questionData.quizChoiceIds[0]

                            return (
                              <div className='choice' key={id}>
                                <RadioField
                                  id={id}
                                  name={questionId}
                                  value={singleValue}
                                  label={body}
                                  onChange={(e) => this.setSingleQuestion(e, questionId)}
                                />
                              </div>
                            )
                          })}
                        </div>
                      )}

                      {form === QUIZ_QUESTION_TYPES.multiple && (
                        <div className='choices'>
                          {choices.map((choice) => {
                            const { body, id } = choice || {}

                            const isChecked =
                              questionData && questionData.quizChoiceIds.find((id) => String(id) === String(choice.id))

                            return (
                              <div className='choice' key={id}>
                                <CheckboxField
                                  name={id}
                                  label={body}
                                  checked={!!isChecked}
                                  onChange={(e) => this.setMultipleQuestion(e, questionId)}
                                />
                              </div>
                            )
                          })}
                        </div>
                      )}
                    </div>
                  )
                })}

              {defaultTheme ? (
                <EloButton orange onClick={() => submitQuiz(this.quizData)}>
                  {I18n.t('shared.common.submit')}
                </EloButton>
              ) : (
                <CustomButton onClick={() => submitQuiz(this.quizData)}>{I18n.t('shared.common.submit')}</CustomButton>
              )}
            </div>
          </div>
        )}
      </Fragment>
    )
  }
}

QuizForm.displayName = 'QuizForm'

export default QuizForm
